import { render } from "./SearchForDatasets.vue?vue&type=template&id=711b7ffc&scoped=true"
import script from "./SearchForDatasets.vue?vue&type=script&lang=js"
export * from "./SearchForDatasets.vue?vue&type=script&lang=js"

import "./SearchForDatasets.vue?vue&type=style&index=0&id=711b7ffc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711b7ffc"]])

export default __exports__